var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ArchivesInfo.jinja');
require('./ArchivesInfo.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArchivesInfo/ArchivesInfo.js
// module id = 156
// module chunks = 0